import { _ as t } from "../internals/export.js";
import { g as s } from "../internals/global.js";
import { s as e } from "../internals/set-to-string-tag.js";
t({
  global: !0
}, {
  Reflect: {}
}), e(s.Reflect, "Reflect", !0);